import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Highlighter from 'react-highlight-words'
import { get } from 'lodash'

import { formatValue } from 'utils/formatters/value'
import { LIST_SIZES } from 'utils/constants/components/dropdown'

import styles from './DefaultRowRenderer.module.scss'

export const DefaultRowRenderer = ({ size = 'regular', item, searchString = '', titleKey = 'title' }) => {
  const itemTitle = get(item, titleKey)

  return (
    <div className={classNames('list-item', styles[size])}>
      <Highlighter
        highlightClassName="text-highlighted"
        searchWords={searchString.split(' ')}
        autoEscape
        textToHighlight={formatValue(itemTitle)}
      />
    </div>
  )
}

DefaultRowRenderer.propTypes = {
  size: PropTypes.oneOf(LIST_SIZES),
  item: PropTypes.object,
  searchString: PropTypes.string,
  titleKey: PropTypes.string,
}
